import { render, staticRenderFns } from "./Recognition.vue?vue&type=template&id=6a5edfda&scoped=true&"
import script from "./Recognition.vue?vue&type=script&setup=true&lang=js&"
export * from "./Recognition.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Recognition.vue?vue&type=style&index=0&id=6a5edfda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5edfda",
  null
  
)

export default component.exports